function attachCfFieldListeners() {
  const fieldContainers = document.querySelectorAll(".cf-field");

  fieldContainers.forEach((container, idx) => {
    // Prevent duplicate listeners
    if (container.dataset.listenersAttached) return;
    container.dataset.listenersAttached = "true";
    const input = container.querySelector("input");
    const label = container.querySelector("label");
    if (input && label) {
      input.addEventListener("focus", () => {
        label.classList.add("focused-label");
      });

      input.addEventListener("blur", () => {
        // Only remove focused-label if input is empty
        if (!input.value) {
          label.classList.remove("focused-label");
        }
      });

      // On page load, if input has value, add focused-label
      if (input.value) {
        label.classList.add("focused-label");
      }
    } else {
      console.warn(`Input or label missing in container ${idx}`);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  attachCfFieldListeners();

  // Observe for dynamically added .cf-field elements
  const observer = new MutationObserver((mutationsList) => {
    let found = false;
    for (const mutation of mutationsList) {
      if (
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.classList?.contains("cf-field") ||
              node.querySelector?.(".cf-field"))
        )
      ) {
        found = true;
        break;
      }
    }
    if (found) {
      attachCfFieldListeners();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
